import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const supportedLngs = ['en', 'ja'];

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: false,
        react: {
            useSuspense: true,
        },
        backend: {
            loadPath: '/{{lng}}.json',
            allowMultiLoading: true,
        },
        supportedLngs,
    });

export default i18n;
export { i18n, supportedLngs };
